import {
  getLocationsBody,
  getLocationsHeader,
  getLocationsMasthead,
  getLocationsRoot,
} from 'redux/modules/content/selectors';
import { getGridAemItems } from 'redux/modules/search-and-browse/selectors';
import getPendingOrders from 'redux/modules/orders/actions/get-pending-orders';

import getChildComponents from 'content/utils/convert-component-tree-to-array';

import { AMEND_ORDER_WIDGET } from '@johnlewispartnership/wtr-content-component-library/dist/component-library/constants/cmsResourceTypes';
import { isPendingOrdersLoaded } from 'redux/modules/orders/selectors/get-orders';

export const componentDataFetcher = () => (dispatch, getState) => {
  const dispatchAndSwallow = action => dispatch(action).catch(() => {});

  const state = getState();
  const components = [
    ...getLocationsBody(state),
    ...getLocationsHeader(state),
    ...getLocationsMasthead(state),
    ...getLocationsRoot(state),
    ...getGridAemItems(state),
  ];

  // Add fetches here to ensure data is loaded on demand for AEM components
  const promises = getChildComponents(components).map((component = {}) => {
    const orderOptions = { iHandleStatusCodes: true };
    const { resourceType } = component;

    switch (resourceType) {
      case AMEND_ORDER_WIDGET: {
        const pendingOrdersLoaded = isPendingOrdersLoaded(state);
        return pendingOrdersLoaded ? null : dispatchAndSwallow(getPendingOrders(orderOptions));
      }
      default:
        return null;
    }
  });

  return Promise.all(promises);
};
